<template>
  <div class="-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon left>mdi-clipboard-text</v-icon>Customers
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="allCustomer = !allCustomer">
              <v-icon left>mdi-plus</v-icon>{{allCustomer?'View Xperience customer':'View all customer' }}
            </v-btn>
            <v-btn text @click="formCustomer = true">
              <v-icon left>mdi-plus</v-icon>Add Customer
            </v-btn>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </template>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalCount"
        >
          <template v-slot:item.actions="{item}">
            <v-btn text icon @click="open(item.id)">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
      <customer-form
        :item="customerToEdit"
        :open="formCustomer"
        v-on:add="addCustomer()"
        v-on:cancel="cancelCustomer()"
        v-on:update="updateCustomer()"
      ></customer-form>
    </div>
  </div>
</template>
<script>
import CustomerForm from "@components/client/CustomerForm";
import _ from "lodash";

export default {
  components: {
    CustomerForm,
  },
  data() {
    return {
      allCustomer: false,
      search: "",
      headers: [
        { text: "Company", value: "company", align: "left" },
        { text: "Last Name", value: "lastname", align: "left" },
        { text: "First Name", value: "firstname" },
        { text: "email", value: "email" },
        { text: "mobile", value: "mobile" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      options: { itemsPerPage: 20 },
      formCustomer: false,
      customerToEdit: null
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getClients();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getClients();
      }, 100)
    },
    allCustomer:{
      handler: _.debounce(function() {
        this.getClients();
      }, 100)
    }
  },
  computed: {
    tableData: function() {
      return this.$store.getters["clients/clients"];
    },
    loading: function() {
      return this.$store.getters["clients/loading"];
    },
    totalCount: function() {
      return this.$store.getters["clients/totalCount"];
    }
  },
  mounted: function() {
    this.getClients(); //method1 will execute at pageload
  },
  methods: {
    getClients() {
      this.$store.dispatch(this.allCustomer?"clients/index":"clients/listXperience", {
        pagination: this.options,
        filter: {
          search: this.search
        }
      });
    },
    addCustomer() {
      this.formCustomer = false;
      this.customerToEdit = null;
      this.getClients();
    },
    cancelCustomer(){
      this.formCustomer=false;
      this.customerToEdit = null;
    },
    open(id) {
      this.$router.push("/clients/view/" + id);
    }
  }
};
</script>
